<template>
  <b-tabs>
    <b-tab title="شرکت های خارجی" active v-if="!(missedTab === 'outSource')">
      <outsource @selectOutsource="selectOutsource" @onRowDoubleClicked="onRowDoubleClicked"></outsource>
    </b-tab>
    <b-tab title="شرکت های داخلی" v-if="!(missedTab === 'company')">
      <company :isSelectMode="true"></company>
    </b-tab>
  </b-tabs>
</template>
<script>
    import Outsource from "../pages/Outsource.vue";
    import Company from "../pages/Company.vue";

    export default {
        props: ["missedTab"],
        components: {
            Company,
            Outsource
        },
        methods: {
            onRowDoubleClicked(data) {
                this.$emit("onRowDoubleClicked", data);
            },
            selectOutsource(data) {
                data.name = data.outSourceName;
                data.type = "outsource";
                this.$emit("selectCompany", data);
            }
        }
    };
</script>
